<template>
    <div ref="wrapper" class="custom-input-bor" :class="`${isEdit ? 'active' : ''} ${error?'error':''}`" :style="`width: ${width}px; height: ${height}px; border: ${border};`">
        <input :disabled="disabled" type="text" @focus="onFocus" ref="input" @input="onInput" @keyup.enter="onEnter" @blur="onBlur" :placeholder="placeholder" v-model="inputValue" class="custom-input" />
        <!-- 单位 -->
        <span v-if="unit" class="unit">{{unit}}</span>
        <span class="unit">
            <slot name="icon" />
        </span>
    </div>
</template>

<script>
    import { inputValidFloat, inputValidInt, inputValidNegInt } from '@/utils/validator'
    export default {
        props: {
            // 单位
            unit: {
                type: String,
                default: null
            },
            width: {
                type: Number,
                default: 65
            },
            height: {
                type: Number,
                default: 31
            },
            // 小数位数 6/2/2
            fix: {
                type: Number,
                default: 6
            },
            // 输入框类型 decimal(小数)/int(整数)/text(字符串)negInt(允许负数整数) negDecimal(允许负数小数)
            type: {
                type: String,
                default: 'decimal'
            },
            value: {
                type: [String, Number],
                default: ''
            },
            placeholder: {
                type: String,
                default: '请输入'
            },
            max: {
                type: Number,
                default: null
            },
            min: {
                type: Number,
                default: null
            },
            step: {
                type: Number,
                default: null
            },
            /**是否禁用 */
            disabled: {
                type: Boolean,
                default: false
            },
            /**是否支持enter抛出数据 */
            enter: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            },
            border:{
                type:String,
                default:'1px solid #e7e7e7'
            }
        },
        watch: {
            'value': function (v) {
                if (this.fix && (this.type === 'decimal' || this.type === 'negDecimal')) {
                    this.inputValue = inputValidFloat(`${v}`, this.fix, this.type === 'decimal')
                } else {
                    this.inputValue = v
                }
            }
        },
        mounted() {
            if (this.fix && (this.type === 'decimal' || this.type === 'negDecimal')) {
                this.inputValue = inputValidFloat(`${this.value}`, this.fix, this.type === 'decimal')
            } else {
                this.inputValue = this.value
            }
        },
        data() {
            return {
                isEdit: false,
                inputValue: '',
                lastInputTime: 0,
                quickcount: 0,
                stash: null,
                stashTask: null,
                error: null,
            }
        },
        methods: {
            onFocus() {
                this.isEdit = true
                this.lastInputTime = 0
                this.quickcount = 0
                this.stash = this.inputValue
            },
            // 处理输入
            onInput(e) {
                if (this.stashTask) {
                    clearTimeout(this.stashTask)
                    this.stashTask = null
                }
                let fromScan = false
                let inputTime = new Date().getTime()
                if (inputTime - this.lastInputTime < 30) {
                    this.quickcount++
                    if (this.quickcount > 5 && e.inputType == 'insertText') { //连续5次快速输入，可能为扫码枪
                        fromScan = true
                    }
                }
                this.lastInputTime = inputTime
                if (fromScan) {
                    this.inputValue = this.stash
                }
                this.stashTask = setTimeout(() => {
                    this.stash = this.value
                }, 300)

                if (this.type === 'text') {
                    this.$emit('input', this.inputValue)
                    return
                }

                let before = this.stash

                // 输入小数且限制小数位数
                if (this.fix >= 0 && (this.type === 'decimal' || this.type === 'negDecimal')) {
                    this.inputValue = inputValidFloat(this.inputValue, this.fix, this.type === 'decimal')
                }
                // 只能输入正整数
                if (this.type === 'int') {
                    this.inputValue = inputValidInt(this.inputValue)
                }
                if (this.type === 'negInt') {
                    this.inputValue = inputValidNegInt(this.inputValue)
                }
                if ((this.max !== undefined && this.max !== null) && Number(this.inputValue) > this.max) {
                    this.inputValue = this.max
                }
                if ((this.min !== undefined && this.min !== null) && String(this.min).length <= String(this.inputValue).length && Number(this.inputValue) < this.min) {
                    this.inputValue = this.min
                }
                if (this.step && Number(this.inputValue) % this.step > 0) {
                    this.inputValue = this.inputValue - Number(this.inputValue) % this.step
                }

                let after = this.inputValue

                // this.inputValue = Number(this.inputValue)
                this.triggerEvent(before, after)
            },

            /**enter */
            onEnter(e) {
                if (this.enter) {
                    this.$emit('enter')
                }
                var currentInput = e.target; // 当前输入框
                var nextInput = getNextInput(currentInput); // 下一个输入框
                if (nextInput) {
                    nextInput.focus();
                    nextInput.select()
                    // e.preventDefault();
                }

            },

            onBlur() {
                if (this.type !== 'text') {
                    if (isNaN(Number(this.inputValue))) {
                        this.inputValue = 0
                    }
                    this.inputValue = this.inputValue !== '' ? Number(this.inputValue) : ''
                }
                this.isEdit = false

                if (this.required && (this.inputValue === '' || this.inputValue == 0 || this.inputValue === null)) {
                    this.error = true
                } else {
                    this.error = false
                }
            },

            // 数据抛出
            triggerEvent(before, after) {
                if (isNaN(Number(this.inputValue))) {
                    return
                }
                this.$emit('input', this.inputValue !== '' ? Number(this.inputValue) : 0)

                //如果当前值和输入前没变化，不触发
                if (before === '' || before === null || before === undefined) before = 0
                if (after === '' || after === null || after === undefined) after = 0
                if (before == after) {
                    return
                }
                if (this.inputValue === '' && this.value === 0) {//在输入框长按删除的情况
                    return
                }

                //如果末位是小数点，不触发
                if (after.toString().endsWith('.')) {
                    return
                }

                this.$emit('change', this.inputValue !== '' ? Number(this.inputValue) : 0)
            },

            /**自动获取焦点 */
            setFocus() {
                this.$refs.input.focus()
            }
        }
    }

    function getNextInput(currentInput) {
        // 获取下一个输入框（循环指定数量的输入框）
        var allInputs = document.getElementsByClassName('custom-input');
        var currentIndex = Array.prototype.indexOf.call(allInputs, currentInput);
        for (var i = 1; i <= allInputs.length; i++) {
            var nextIndex = (currentIndex + i) % allInputs.length;
            var nextInput = allInputs[nextIndex];
            if (nextInput !== currentInput && !nextInput.disabled && !nextInput.readOnly) {
                return nextInput;
            }
        }
    }
</script>

<style scoped>
    .custom-input-bor {
        border: 1px solid #e7e7e7;
        border-radius: 4px;
        padding: 5px;
        position: relative;
        display: flex;
        align-items: center;
    }

    .custom-input-bor.active {
        border: 1px solid #20bf64;
    }

    .custom-input {
        border: none;
        outline: none;
        width: 100%;
        color: #585859;
        height: 100%;
    }

    .custom-input::placeholder {
        color: #999999;
    }

    .unit {
        position: absolute;
        right: 5px;
        line-height: 2;
        /* width: 20px; */
        background: #fff;
        /* padding-left: 5px; */
        height: 100%;
    }

    .error {
        border: 1px solid red;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/CustomInput.vue?55a3e8fa